var map = {
	"./fast-deep-cinematic-whoosh-swo.mp3": [
		794,
		794
	],
	"./fast-deep-cinematic-whoosh-swo.wav": [
		29,
		29
	],
	"./small-short-deep-whoosh.mp3": [
		368,
		368
	],
	"./small-short-deep-whoosh.wav": [
		415,
		415
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 641;
module.exports = webpackAsyncContext;